module.exports = __webpack_public_path__ + "static/img/技能强国1.0919ecb9.png";